export const base64Utils = {
  encode: (str: string): string => {
    if (!str) return '';
    try {
      return btoa(str);
    } catch (error) {
      console.error('Error encoding to base64:', error);
      return str;
    }
  },

  decode: (encodedStr: string): string => {
    if (!encodedStr) return '';
    try {
      return atob(encodedStr);
    } catch (error) {
      console.error('Error decoding from base64:', error);
      return encodedStr;
    }
  }
};